module.exports = __webpack_public_path__ + "img/republican.1d238025.svg";